import { Typography, Tooltip, CSSObject } from '@mui/material';
import { Grading } from '@mui/icons-material';

export type Props = {
    onClick: () => void;
};

const labelStyles: CSSObject = {
    color: '#ffffff',
    fontSize: '1rem',
    position: 'relative',
    top: '-0.094rem',
};

const ButtonAssessmentPreview = ({ onClick }: Props) => {
    const iconStyles = {
        color: 'primary.main',
        '&:hover': {
            color: 'secondary.main',
            cursor: 'pointer',
        },
    };

    return (
        <Tooltip
            title={
                <Typography variant="body1" sx={labelStyles}>
                    Click to preview.
                </Typography>
            }
            placement="top"
        >
            <Grading aria-label="preview assessment" sx={iconStyles} onClick={onClick} />
        </Tooltip>
    );
};

export default ButtonAssessmentPreview;
